export enum UserRouteNameEnum {
	details = "user.details",
	// Single status-driven screen for the account-lifecycle states:
	// pending_moderation (under review), suspended (blocked) and rejected
	// (shows the reason + lets the user fix & resubmit).
	accountStatus = "user.account-status",
	profileGeneral = "user.profile.general",
	profileNotifications = "user.profile.notifications",
	profileEdit = "user.profile.edit",
}
